/**
 * Escape user-supplied text for safe interpolation into an HTML string.
 *
 * Needed wherever markup is assembled by hand and handed to something
 * that parses it as HTML — the generated briefing PDFs, and the crew
 * popups on the live map (mapbox's setHTML is innerHTML underneath).
 * Crew names, stage names and assignment notes are all producer input,
 * so none of them can be trusted to be markup-free.
 *
 * Quotes are escaped too, so the result is also safe inside a quoted
 * attribute value, not just in text content.
 */
export function escapeHtml(value: string | null | undefined): string {
  if (value == null) return "";
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}
